import { render, staticRenderFns } from "./TodayCateringsTable.vue?vue&type=template&id=38c63c61&"
import script from "./TodayCateringsTable.vue?vue&type=script&lang=js&"
export * from "./TodayCateringsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports